(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const animBusy = U.animBusy;
  const artStyle = U.artStyle;
  const backSvg = U.backSvg;
  const beginDrag = U.beginDrag;
  const cardActions = U.cardActions;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const closeInspector = U.closeInspector;
  const dispatch = U.dispatch;
  const el = U.el;
  const esc = U.esc;
  const groupMoveDests = U.groupMoveDests;
  const live = U.live;
  const markStates = U.markStates;
  const pcls = U.pcls;
  const poolToken = U.poolToken;
  const renderHandCard = U.renderHandCard;
  const setShowLog = U.setShowLog;
  const togglePick = U.togglePick;
  const viewPlayer = U.viewPlayer;

  function menuRow(a, onPick) {
    const row = el("div", "menurow" + (a.primary ? " primary" : "") + (a.disabled ? " off" : ""));
    row.appendChild(el("span", "ml", U.fmtText(a.label)));
    if (a.disabled && a.why) row.appendChild(el("span", "mw", U.fmtText(a.why)));
    if (!a.disabled) {
      row.onclick = function (ev) {
        ev.stopPropagation();
        onPick();
      };
    }
    return row;
  }

  function renderRuneDeckMenu(state) {
    const m = APP.menu;
    const div = el("div");
    div.id = "cardmenu";
    div.className = "pilemenu";
    div.appendChild(el("div", "menutitle", U.fmtText(m.title)));
    const left = state.players[m.player].runeDeck.length;
    div.appendChild(menuRow({
      label: left + " rune" + (left === 1 ? "" : "s") + " left to channel", disabled: true,
    }, function () { }));
    div.appendChild(menuRow({
      label: "Manual pay: " + (APP.manualPay ? "On" : "Off"), primary: APP.manualPay,
      why: APP.manualPay
        ? "Costs open the payment panel so you pick the runes."
        : "Costs pay themselves.",
    }, function () {
      closeInspector();
      U.setManualPay(!APP.manualPay);
    }));
    return div;
  }

  function renderPileMenu(state) {
    const m = APP.menu;
    if (m.kind === "runedeck") return renderRuneDeckMenu(state);
    const div = el("div");
    div.id = "cardmenu";
    div.className = "pilemenu";
    div.appendChild(el("div", "menutitle", U.fmtText(m.title)));
    if (m.stage === "choose") {
      div.appendChild(menuRow({ label: "See" }, function () {
        closeInspector();
        U.showPile(m.title, m.ids, true);
      }));
      div.appendChild(menuRow({ label: "Activate", primary: true }, function () {
        APP.menu = Object.assign({}, m, { stage: "activate" });
        U.render();
      }));
      return div;
    }
    const acts = U.pileActivations(state, m.ids);
    if (!acts.length) return null;
    for (const entry of acts) {
      (function (entry) {
        const a = entry.action;
        div.appendChild(menuRow({ label: Core.name(state, entry.iid) + " — " + U.plainText(a.label), primary: a.primary }, function () {
          APP.menu = null;
          APP.selection = null;
          a.fn();
        }));
      })(entry);
    }
    div.appendChild(menuRow({ label: "Back" }, function () {
      APP.menu = Object.assign({}, m, { stage: "choose" });
      U.render();
    }));
    return div;
  }

  function zoomStatus(state, iid) {
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    if (!o || !c) return "";
    const parts = [];
    if (o.zone === "board") {
      parts.push(o.ready ? "Ready" : "Exhausted");
      const m = Core.effMight(state, iid);
      if (m !== null && m !== undefined) {
        const printed = c.might !== null && c.might !== undefined && m !== c.might ? " (printed " + c.might + ")" : "";
        parts.push(m + " Might" + printed);
      }
      const dmg = Core.totalDamage(o);
      if (dmg) parts.push(dmg + " damage");
      if (o.stunned) parts.push("Stunned");
      if (o.empowered) parts.push("Empowered");
      if (o.designation) parts.push(o.designation === "attacker" ? "Attacker" : "Defender");
      if (o.named) parts.push("Names " + o.named.value);
      for (const f of U.lingeringOn(state, iid)) parts.push("Later: " + f.label + " (" + U.lingerWhen(f) + ")");
      if (o.controlSrc && state.objs[o.controlSrc]) {
        parts.push("On loan from " + state.players[o.owner].name + " (while " + Core.name(state, o.controlSrc) + " stays)");
      }
      if (o.replacedBf && state.objs[o.replacedBf]) parts.push("Replaced " + Core.name(state, o.replacedBf));
      const bw = (o.flags && o.flags.banishedWith) || [];
      if (bw.length) parts.push(bw.length + " banished with it");
      const kws = Core.keywords(state, iid);
      const names = Object.keys(kws).filter(function (k) { return kws[k]; }).map(function (k) {
        return k.charAt(0).toUpperCase() + k.slice(1) + (typeof kws[k] === "number" && kws[k] > 1 ? " " + kws[k] : "");
      });
      if (names.length) parts.push(names.join(", "));
    } else if (o.zone === "hand") parts.push("In hand");
    else if (o.zone === "trash") parts.push("In trash");
    else if (o.zone === "chain") parts.push("On the chain");
    if (o.controller !== undefined && state.players[o.controller]) parts.unshift(state.players[o.controller].name);
    return parts.join(" · ");
  }

  function renderCardMenu(state) {
    if (APP.menu && APP.menu.pile) return renderPileMenu(state);
    if (!APP.menu || !state.objs[APP.menu.iid]) return null;
    const iid = APP.menu.iid;
    const c = Core.card(state, iid);
    const acts = cardActions(state, iid);
    if (!acts.length) return null;
    const div = el("div");
    div.id = "cardmenu";
    div.appendChild(el("div", "menutitle", esc(c ? c.name : "")));
    for (const a of acts) {
      (function (a) {
        div.appendChild(menuRow(a, function () {
          APP.menu = null;
          APP.selection = null;
          a.fn();
        }));
      })(a);
    }
    return div;
  }

  function choiceRowLabel(state, iid) {
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    if (!o || !c) return { name: "?", sub: "" };
    let where = "";
    if (o.zone === "board") {
      where = o.loc ? Core.locName(state, o.loc) : "board";
      const m = Core.effMight(state, iid);
      if (m !== null && m !== undefined) where += " · " + m + " Might";
      const dmg = Core.totalDamage(o);
      if (dmg) where += " · " + dmg + " dmg";
    } else if (o.zone === "trash") where = "Trash";
    else if (o.zone === "hand") where = "Hand";
    else if (o.zone === "chain") where = "On the chain";
    else where = o.zone;
    if (o.controller !== undefined && state.players[o.controller]) {
      where = state.players[o.controller].name + " · " + where;
    }
    return { name: c.name, sub: where };
  }

  function renderTriggerOrderMenu(state, pd) {
    if (APP.trigOrderQueue && APP.trigOrderQueue.length) return null;
    const sig = JSON.stringify(pd.options);
    if (APP.trigOrderSig !== sig) {
      APP.trigOrderSig = sig;
      APP.trigOrder = {};
    }
    APP.trigOrder = APP.trigOrder || {};
    const assigned = Object.keys(APP.trigOrder).length;

    const div = el("div");
    div.id = "choicemenu";
    div.appendChild(el("div", "menusrc", "Simultaneous triggers"));
    div.appendChild(el("div", "menutitle", "Click them in the order they go on the chain — 1 resolves last, the highest number resolves first"));
    div.appendChild(el("div", "menunote", assigned + " of " + pd.options.length + " placed"));

    const strip = el("div", "choicestrip");
    for (let i = 0; i < pd.options.length; i++) {
      (function (i) {
        const num = APP.trigOrder[i];
        const tile = el("div", "choicecard" + (num !== undefined ? " picked" : ""));
        const art = el("div", "cart");
        const cid = pd.srcCards && pd.srcCards[i];
        const c = cid ? RB.Setup.findCard(cid) : null;
        if (c) {
          art.style.backgroundImage = RB.artCssAt(c, 112);
          art.style.backgroundSize = "cover";
          art.style.backgroundPosition = "center";
        } else {
          art.classList.add("baseart");
        }
        if (num !== undefined) art.appendChild(el("div", "trignum", String(num)));
        tile.appendChild(art);
        const cap = el("div", "ccap");
        cap.appendChild(el("div", "cn", U.fmtText(pd.options[i])));
        cap.appendChild(el("div", "cs", num !== undefined
          ? (num === 1 ? "Placed 1st — resolves last" : "Placed " + num + (num === pd.options.length ? " — resolves first" : ""))
          : "Click to place next"));
        tile.appendChild(cap);
        tile.title = pd.options[i];
        tile.onclick = function (ev) {
          ev.stopPropagation();
          if (APP.trigOrder[i] !== undefined) {
            const removed = APP.trigOrder[i];
            delete APP.trigOrder[i];
            for (const k in APP.trigOrder) {
              if (APP.trigOrder[k] > removed) APP.trigOrder[k] -= 1;
            }
          } else {
            APP.trigOrder[i] = Object.keys(APP.trigOrder).length + 1;
          }
          U.render();
        };
        strip.appendChild(tile);
      })(i);
    }
    div.appendChild(strip);

    const foot = el("div", "menufoot");
    const ok = el("button", "btn primary", "Confirm chain order");
    ok.disabled = assigned !== pd.options.length;
    if (ok.disabled) ok.title = "Number every trigger first (" + assigned + "/" + pd.options.length + ")";
    ok.onclick = function (ev) {
      ev.stopPropagation();
      const order = Object.keys(APP.trigOrder)
        .sort(function (a, b) { return APP.trigOrder[a] - APP.trigOrder[b]; })
        .map(function (k) { return pd.options[+k]; });
      APP.trigOrder = {};
      APP.trigOrderSig = null;
      APP.trigOrderQueue = order.slice(1);
      dispatch({ type: "CHOOSE", player: pd.player, optionIdx: pd.options.indexOf(order[0]) });
    };
    foot.appendChild(ok);
    div.appendChild(foot);
    return div;
  }

  function candRank(state, me, iid) {
    const o = typeof iid === "string" && iid.indexOf("chain:") !== 0 ? state.objs[iid] : null;
    if (!o || o.zone !== "board" || !o.loc) return [2, 0, 0];
    const side = o.controller === me ? 0 : 1;
    if (o.loc.t === "base") return [side, 0, 0];
    return [side, 1, state.battlefields.indexOf(o.loc.iid)];
  }

  function orderCands(state, cands) {
    const me = viewPlayer(state);
    const keyed = cands.map(function (iid, i) { return { iid: iid, i: i, k: candRank(state, me, iid) }; });
    keyed.sort(function (a, b) {
      for (let j = 0; j < 3; j++) if (a.k[j] !== b.k[j]) return a.k[j] - b.k[j];
      return a.i - b.i;
    });
    return keyed.map(function (x) { return x.iid; });
  }

  function hoverTarget(ev) {
    const t = ev.target && ev.target.closest ? ev.target.closest("[data-iid]") : null;
    if (!t || !document.getElementById("choicemenu")) return null;
    return t;
  }

  if (typeof document !== "undefined" && document.addEventListener) {
    document.addEventListener("mouseover", function (ev) {
      const t = hoverTarget(ev);
      if (!t) return;
      const iid = t.getAttribute("data-iid");
      U.flashBoardCard(iid, true);
      if (!t.classList.contains("choicecard")) {
        const tile = document.querySelector("#choicemenu .choicecard[data-iid='" + iid + "']");
        if (tile && tile.scrollIntoView) tile.scrollIntoView({ block: "nearest", inline: "center" });
      }
    });
    document.addEventListener("mouseout", function (ev) {
      const t = hoverTarget(ev);
      if (t) U.flashBoardCard(t.getAttribute("data-iid"), false);
    });
  }

  function renderChoiceMenu(state) {
    if (!live()) return null;
    if (animBusy()) return null;
    const pd = state.pending;
    if (!pd || pd.kind !== "choose") return null;
    if (!U.localDecision(state)) return null;
    if (pd.tag === "predict") return null;
    if (pd.tag === "orderTriggers") return renderTriggerOrderMenu(state, pd);

    const div = el("div");
    div.id = "choicemenu";
    if (pd.src) {
      div.appendChild(el("div", "menusrc", U.fmtText(pd.src)));
      div.appendChild(el("div", "menutitle",
        U.fmtText((pd.step ? "Step " + pd.step.n + " of " + pd.step.of + " — " : "") + (pd.prompt || "Choose"))));
    } else {
      div.appendChild(el("div", "menutitle", U.fmtText(pd.prompt || "Choose")));
    }
    if (pd.hint) div.appendChild(el("div", "menuhint", U.fmtText(pd.hint)));

    if (pd.tag === "name") {
      div.appendChild(U.renderNameInput(state, pd));
      return div;
    }
    if (pd.split) return null;

    if (pd.options) {
      const strip = el("div", "optstrip");
      for (let i = 0; i < pd.options.length; i++) {
        (function (i) {
          const b = el("button", "btn" + (i === 0 ? " primary" : ""), U.fmtText(pd.options[i]));
          b.onclick = function (ev) {
            ev.stopPropagation();
            dispatch({ type: "CHOOSE", player: pd.player, optionIdx: i });
          };
          strip.appendChild(b);
        })(i);
      }
      div.appendChild(strip);
      return div;
    }

    const min = pd.min !== undefined ? pd.min : 1;
    const max = pd.max !== undefined ? pd.max : 1;
    div.appendChild(el("div", "menunote", APP.picked.length + " of " + max + " selected" +
      (min ? " (need " + min + ")" : " (optional)") +
      (pd.cohere === "loc" ? " — all at one location" : "") + " — click a card to read it, then confirm"));

    const strip = el("div", "choicestrip");
    if (!pd.locChoices) div.classList.add("band");

    if (pd.locChoices) {
      for (const loc of pd.cands) {
        (function (loc) {
          const tile = el("div", "choicecard");
          const art = el("div", "cart");
          if (loc.t === "bf") artStyle(art, state, loc.iid, "bf", 200);
          else art.classList.add("baseart");
          tile.appendChild(art);
          const cap = el("div", "ccap");
          cap.appendChild(el("div", "cn", esc(Core.locName(state, loc))));
          cap.appendChild(el("div", "cs", loc.t === "bf" ? "Battlefield" : "Your base"));
          tile.appendChild(cap);
          tile.onclick = function (ev) {
            ev.stopPropagation();
            dispatch({ type: "CHOOSE", player: pd.player, picks: [loc] });
          };
          strip.appendChild(tile);
        })(loc);
      }
      div.appendChild(strip);
      return div;
    }

    for (const iid of orderCands(state, pd.cands)) {
      (function (iid) {
        const picked = APP.picked.indexOf(iid) >= 0;
        const tile = el("div", "choicecard" + (picked ? " picked" : ""));
        tile.setAttribute("data-iid", iid);
        const isChainRef = typeof iid === "string" && iid.indexOf("chain:") === 0;
        const art = el("div", "cart");
        const cap = el("div", "ccap");
        if (isChainRef) {
          const it = state.chain.find(function (x) { return "chain:" + x.id === iid; });
          if (it && it.iid) artStyle(art, state, it.iid, "full");
          cap.appendChild(el("div", "cn", esc(it ? it.label : String(iid))));
          cap.appendChild(el("div", "cs", "On the chain"));
        } else {
          artStyle(art, state, iid, "full");
          const info = choiceRowLabel(state, iid);
          const o = state.objs[iid];
          if (o && o.zone === "board" && Core.isType(state, iid, "unit")) {
            const m = Core.effMight(state, iid);
            if (m !== null && m !== undefined) art.appendChild(el("div", "cmight", String(m)));
          }
          cap.appendChild(el("div", "cn", esc(info.name)));
          cap.appendChild(el("div", "cs", esc(info.sub)));
          tile.title = cardTitle(state, iid);
        }
        if (picked) art.appendChild(el("div", "ccheck", "✓"));
        tile.appendChild(art);
        tile.appendChild(cap);
        const allowed = !U.cohereAllows || U.cohereAllows(iid);
        if (!allowed) tile.classList.add("off");
        tile.onclick = function (ev) {
          ev.stopPropagation();
          if (allowed) togglePick(iid);
        };
        strip.appendChild(tile);
      })(iid);
    }
    div.appendChild(strip);

    const foot = el("div", "menufoot");
    for (const b of U.confirmButtons(pd)) foot.appendChild(b);
    if (pd.cancellable) foot.appendChild(U.cancelButton(pd));
    div.appendChild(foot);
    return div;
  }

  function positionCardMenu() {
    if (!APP.menu || typeof window === "undefined") return;
    const m = document.getElementById("cardmenu");
    if (!m || !m.getBoundingClientRect) return;
    const sel = APP.menu.pile ? "[data-anchor='" + APP.menu.pile + "']" : "[data-iid='" + APP.menu.iid + "']";
    const anchor = document.querySelector && document.querySelector(sel);
    const anchorRect = anchor && anchor.getBoundingClientRect && anchor.getBoundingClientRect();
    if (!anchorRect || (!anchorRect.width && !anchorRect.height)) {
      const mr0 = m.getBoundingClientRect();
      m.style.left = Math.round(Math.max(8, (window.innerWidth - mr0.width) / 2)) + "px";
      m.style.top = Math.round(Math.max(8, (window.innerHeight - mr0.height) / 2)) + "px";
      return;
    }
    U.placeFloating(m, anchorRect, { side: "above", pad: 10 });
  }

  Object.assign(U, { orderCands: orderCands, renderCardMenu: renderCardMenu, renderChoiceMenu: renderChoiceMenu, positionCardMenu: positionCardMenu, zoomStatus: zoomStatus });
})();
